// extracted by mini-css-extract-plugin
export default {"primeArtifactPropertiesManager":"PrimeArtifactPropertiesManager_primeArtifactPropertiesManager__D46YB"};